module.exports = __webpack_public_path__ + "img/dark-trash-can.f00692d4.svg";